import React from 'react';

import BaseMeta from './BaseMeta';
import OpenGraphMeta from './OpenGraphMeta';
import TwitterMeta from './TwitterMeta';

const BASE_TITLE = 'Atlassian Marketplace';

type MetaTypes = {
  canonicalUrl: string;
  description: string;
  image: string;
  openGraphImage: string;
  title: string;
  twitterImage: string;
};
const Meta = ({
  canonicalUrl,
  description,
  image,
  openGraphImage,
  title,
  twitterImage,
}: MetaTypes) => {
  const GeneratedTitle = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
  return (
    <>
      <BaseMeta canonicalUrl={canonicalUrl} description={description} title={GeneratedTitle} />
      <OpenGraphMeta
        canonicalUrl={canonicalUrl}
        description={description}
        image={openGraphImage || image}
        title={GeneratedTitle}
      />
      <TwitterMeta description={description} image={twitterImage || image} title={GeneratedTitle} />
    </>
  );
};

export default Meta;
